/**
 * Where a reminder takes you when you click it.
 *
 * Reminders are written by the API with `residence_id` plus the record they came
 * from (`source_type` / `source_id` — see api/utils/reminderService.js). This is
 * the one place those are turned into a dashboard URL, so the Dashboard card and
 * the resident page's own card always agree.
 *
 * The resident page reads `?tab=<slug>` to choose a tab and `?focus=<id>` to
 * select one record inside it (see TAB_BY_SLUG in ResidenceDetails.js).
 */

// Reminder type → resident-page tab slug.
const TAB_FOR_TYPE = {
  care_plan_review: 'care-plan',
  risk_assessment_review: 'risk-assessment',
  incident_followup: 'incidents',
  allergy_flag_review: 'personal',
  custom: 'personal',
};

// Slug → the tab's label on the resident page. Exported for ResidenceDetails.
export const TAB_BY_SLUG = {
  personal: 'Personal details',
  medication: 'Medication',
  'care-notes': 'Care notes',
  'care-plan': 'Care plan',
  'risk-assessment': 'Risk Assessment',
  incidents: 'Accident & Incident',
  'body-map': 'Body map',
};

/**
 * The URL to open for a reminder, or null when there is nowhere to go (a
 * custom reminder that isn't about any resident).
 */
export const reminderLink = (r) => {
  if (!r || !r.residence_id) return null;
  const tab = TAB_FOR_TYPE[r.type] || 'personal';
  const params = new URLSearchParams({ tab });
  // Only the typed reminders point at one record in their tab.
  if (r.source_id && tab !== 'personal') params.set('focus', String(r.source_id));
  return `/manager/residences/${r.residence_id}?${params.toString()}`;
};
